import React from 'react';
import { PropsWithChildren } from 'react';
import Typography from '@material-ui/core/Typography';

const Title: React.FC<PropsWithChildren<object>> = ({ children }) => (
  <Typography component="h2" variant="h6" color="primary" gutterBottom>
    {children}
  </Typography>
);

export default Title;
